import { PpjBonusWithSummary } from '../sdk/sdk';

export function showPpjPaidButton(
  ppj: PpjBonusWithSummary | undefined,
  isNonInstallable: boolean,
): boolean {
  return ppj !== undefined && ppj.paidAt == null && !isNonInstallable;
}

export function normalizeBudget(raw: number | string | null | undefined): number | null {
  if (raw === '' || raw === null || raw === undefined) {
    return null;
  }

  const value = typeof raw === 'number' ? raw : Number(raw);
  return Number.isNaN(value) ? null : value;
}

/**
 * Converts a percentage into dollars against a basis. The only caller is the PPJ foreman bonus
 * modal, which always passes the bonus pot — never an adjusted sale, despite what an earlier name
 * for this claimed. The pot may be negative since 2026-08-12, so the guard is division-safety and
 * "nothing to take a share of", never the sign.
 */
export function dollarsFromPercentOfBasis(
  percent: number | string | null | undefined,
  basis: number | null,
): number | null {
  const normalizedPercent = normalizeBudget(percent);
  if (normalizedPercent === null || basis === null || basis === 0) {
    return null;
  }

  return Math.round(basis * (normalizedPercent / 100) * 100) / 100;
}

/** The reverse of {@link dollarsFromPercentOfBasis}; see there for what `basis` is. */
export function percentFromDollarsOfBasis(
  dollars: number | null,
  basis: number | null,
): number | null {
  if (dollars === null || basis === null || basis === 0) {
    return null;
  }

  return Math.round((dollars / basis) * 100 * 100) / 100;
}

export function budgetedLaborPercent(
  bonusPot: number | null,
  actualLaborCost: number | null,
  adjustedSale: number | null,
): number | null {
  if (bonusPot === null || actualLaborCost === null || adjustedSale === null || adjustedSale === 0) {
    return null;
  }

  return ((bonusPot + actualLaborCost) / adjustedSale) * 100;
}
